import { api } from './api';
import { endpoints } from './endpoints';

const getLLMSuggestionsGiftMessage = body =>
  api.post(endpoints.getLLMSuggestionsGiftMessage(), body).then(response => response.data.data);

const getLLMSuggestionsProductFilters = body =>
  api.post(endpoints.getLLMSuggestionsProductFilters(), body).then(response => response.data.data);

export { getLLMSuggestionsGiftMessage, getLLMSuggestionsProductFilters };
